export default __webpack_public_path__ + "static/media/plan_complexity_question.c703081f.png";